import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Andreas Gohr
 * id 4AA96763-2A6C-4BF0-BA64-32AD08B530F6
 * name format-wrap-tight
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-wrap-tight.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatWrapTightIcon = createSvgIcon(<><path d="M12,7L17,17H7L12,7M3,3H21V5H3V3M3,7H9V9H3V7M21,7V9H15V7H21M3,11H7V13H3V11M21,11V13H17V11H21M3,15H6V17H3V15M21,15V17H18V15H21M3,19H21V21H3V19Z" /></>, 'FormatWrapTightIcon');
export default FormatWrapTightIcon